/**
 * Variation Code Constants
 * variation_code関連の共通定数定義
 *
 * @description
 * variation_codeの構築・解析に使用する定数を一元管理
 * Shopifyテーマ全体で使用可能なグローバル定数
 *
 * @version 1.0.0
 */

(function() {
  'use strict';

  /**
   * Variation Code 定数
   * @namespace VariationCodeConstants
   */
  const VariationCodeConstants = {
    /**
     * variation_codeの区切り文字
     * @type {string}
     * @example 'コート90kg_片面カラー' -> ['コート90kg', '片面カラー']
     */
    SEPARATOR: '_',

    /**
     * デフォルト値（バリエーションがない場合）
     * @type {string}
     */
    STANDARD_VALUE: '標準',

    /**
     * ページ範囲の正規表現パターン
     * @type {RegExp}
     * @example '16-28P', '24-32P'
     */
    PAGE_RANGE_PATTERN: /^\d+-\d+P$/,

    /**
     * 用紙重量の正規表現パターン
     * @type {RegExp}
     * @example 'コート90kg', 'マット110kg'
     */
    PAPER_WEIGHT_PATTERN: /\d+kg$/i,

    /**
     * 用紙名リスト
     * 用紙判定に使用するキーワード
     * @type {string[]}
     */
    PAPER_NAMES: [
      'コート',
      'マット',
      '上質',
      'アート',
      '書籍用紙',
      'アートポスト',
      'ケント',
      'FSC認証用紙コート',
      'FSC認証用紙マット',
      'FSC認証用紙上質'
    ],

    /**
     * 印刷色数キーワード
     * 印刷色数判定に使用するキーワード
     * @type {string[]}
     */
    PRINT_COLOR_KEYWORDS: [
      '色',
      'カラー',
      'モノクロ',
      '１色',
      '1色',
      '２色',
      '2色',
      '４色',
      '4色',
      '片面',
      '両面',
      '全頁'
    ],

    /**
     * パターンタイプ定義
     * 商品タイプの分類
     * @type {Object}
     */
    PATTERN_TYPES: {
      /** 単一バリアント商品（用紙・印刷色数の組み合わせ） */
      SIMPLE: 'simple',
      /** 冊子商品（本文紙質・表紙紙質の組み合わせ） */
      BOOKLET: 'booklet',
      /** 単一バリアント＋複数用紙variation形式 */
      SINGLE: 'single'
    },

    /**
     * オプション名の定義
     * Shopifyオプション名の標準定義
     * @type {Object}
     */
    OPTION_NAMES: {
      /** 用紙オプション */
      PAPER: '用紙',
      /** 印刷色数オプション */
      PRINT_COLOR: '印刷色数',
      /** ページ数オプション */
      PAGE_COUNT: 'ページ数',
      /** ページ範囲オプション */
      PAGE_RANGE: 'ページ範囲',
      /** 本文紙質オプション（冊子用） */
      BODY_PAPER: '本文紙質',
      /** 表紙紙質オプション（冊子用） */
      COVER_PAPER: '表紙紙質',
      /** タイプオプション */
      TYPE: 'タイプ'
    },

    /**
     * 特殊な表紙紙質の値
     * @type {string}
     */
    COVER_SAME_AS_BODY: '本文と同じ'
  };

  // グローバルに公開（windowオブジェクト経由）
  window.VariationCodeConstants = VariationCodeConstants;

  // 個別定数もグローバルに公開（後方互換性のため）
  window.VARIATION_CODE_SEPARATOR = VariationCodeConstants.SEPARATOR;
  window.VARIATION_CODE_STANDARD = VariationCodeConstants.STANDARD_VALUE;
  window.PAGE_RANGE_PATTERN = VariationCodeConstants.PAGE_RANGE_PATTERN;
  window.PAPER_WEIGHT_PATTERN = VariationCodeConstants.PAPER_WEIGHT_PATTERN;
  window.PAPER_NAMES = VariationCodeConstants.PAPER_NAMES;
  window.PRINT_COLOR_KEYWORDS = VariationCodeConstants.PRINT_COLOR_KEYWORDS;
  window.PATTERN_TYPES = VariationCodeConstants.PATTERN_TYPES;

})();
